<template>
    <div class="picker__container">
        <div class="picker-wrapper">
            <div class="picker__preview" @click="openPicker" :style="{backgroundColor: chosenColor}"></div>
            <ul v-if="pickerOpen" class="picker__list" v-click-outside="closePicker">
                <li v-for="item of colors" :name="item" @click="chooseColor(item)" class="picker__list-item" :style="{backgroundColor: item}"></li>
            </ul>
            <input @input="setFromInput" @blur="setFromBlur" type="text" :value="chosenColor" class="picker__input" placeholder="" />
        </div>
    </div>

</template>

<script>
    import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive,
            },
        props: ['defaultColor', 'setColor'],
        data() {
            return {
                pickerOpen: false,
                chosenColor: null,
                startColor: null,
                error: false,
                colors: [
                    "#ff80ed",
                    "#065535",
                    "#000000",
                    "#133337",
                    "#ffc0cb",
                    "#ffffff",
                    "#ffe4e1",
                    "#008080",
                    "#ff0000",
                    "#e6e6fa",
                    "#ffd700",
                    "#00ffff",
                    "#ffa500",
                    "#0000ff",
                    "#c6e2ff",
                    "#ff7373",
                    "#40e0d0",
                    "#b0e0e6",
                    "#d3ffce",
                    "#f0f8ff",
                    "#666666",
                    "#faebd7",
                    "#bada55",
                    "#fa8072",
                    "#003366",
                    "#ffb6c1",
                    "#c0c0c0",
                    "#ffff00"
                ]
            }
        },
        methods: {
            openPicker() {
                if (this.pickerOpen) {
                    return
                } else {
                    this.pickerOpen = true;
                };
            },
            closePicker() {
                if (this.pickerOpen === false) {
                    return
                };
                    this.pickerOpen = false;
            },
            chooseColor(color) {
                this.chosenColor = color;
                this.setColor(color)
                this.closePicker();
            },
            setFromInput(e) {
                this.chosenColor = e.target.value;
                this.setColor(this.chosenColor);
            },
            setFromBlur() {
                const array = this.chosenColor.split('');

                if ((array.length !== 4 && array.length === 7) || (array.length === 4 && array.length !== 7) && array.includes('#')) {
                        this.error = false;
                    } else {
                        this.chosenColor = this.startColor
                        this.setColor(this.startColor);
                        this.error = true;
                        
                    }
            }
        },
        mounted() {
            this.chosenColor = this.$props.defaultColor,
            this.startColor = this.$props.defaultColor
        },
        // watch: {
        //     chosenColor: {
        //         deep: true,
        //         handler: function () {
        //             const array = this.chosenColor.split('');

        //             // console.log((array.length !== 4 && array.length === 7) || (array.length === 4 && array.length !== 7), !array.includes('#'))
        //             if ((array.length !== 4 && array.length === 7) || (array.length === 4 && array.length !== 7) || !array.includes('#')) {
        //                 this.error = true;
        //             } else {
        //                 this.error = false;
        //             }
        //         }
        //     }
        // }
        
    }
</script>

<style scoped lang="scss">
    .picker__container {
        position: relative;
    }

    .picker__preview {
        min-width: 48px;
        max-width: 48px;
        height: 48px;
        border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
        border-radius: 6px;
        cursor: pointer;
    }

    .picker__list {
        list-style: none;
        position: absolute;
        top: -50%;
        left: 55px;
        display: grid;
        grid-template-columns: repeat(7, 20px);
        grid-template-rows: repeat(4, 20px);
        gap: 5px;
        padding: 5px;
        border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
        background-color: #F8F9FA;
        border-radius: 6px;
    }

    .picker-wrapper {
        display: flex;
        gap: 16px;
        max-width: 312px;
    }

    .picker__list-item {
        cursor: pointer;
        border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
        border-radius: 3px;
    }

    .picker__input {
        outline: none;
        height: 48px;
        width: 100%;
        /* max-width: 241px; */
        padding: 12px 20px 12px 20px;
        border: 1px solid var(--light-mode-system-grey-4, #d1d1d6);
        color: #828f9a;
        border-radius: 6px;
        font-family: "Inter", sans-serif;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: -0.17px;
        transition: all 150ms linear;

        &:focus-visible {
            border-color: rgb(49, 130, 206);
            box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
        }
    }
</style>